export default {
}



// WEBPACK FOOTER //
// src/store/socket/getters.js